import {ComponentType} from "react";
import {flushSync} from "react-dom";
import {createRoot} from "react-dom/client";

import {CreateTurnstileChallengeContainer, TurnstileWidgetTheme} from "./turnstile_challenge_container";

const TURNSTILE_WIDGET_HOST_ATTRIBUTE = "data-turnstile-widget-host";

export interface ITurnstileChallengeViewProps {
    /*
    The view must stay mounted in both states and toggle its visibility with CSS only. Turnstile renders its iframe into the
    widget host before the view opens and reparenting a live iframe reloads it, which breaks the challenge.
    */
    isOpen: boolean;
    onDismiss?: () => void;
}

interface ITurnstileWidgetHostProps {
    className?: string;
}

// Marks the element the Turnstile widget is rendered into - the view must render it exactly once
export const TurnstileWidgetHost = ({className}: ITurnstileWidgetHostProps) => <div className={className} {...{[TURNSTILE_WIDGET_HOST_ATTRIBUTE]: "true"}} />;

interface ICreateReactTurnstileChallengeContainerConfig {
    ChallengeView: ComponentType<ITurnstileChallengeViewProps>;
    widgetTheme?: TurnstileWidgetTheme;
}

export const createReactTurnstileChallengeContainer =
    ({ChallengeView, widgetTheme}: ICreateReactTurnstileChallengeContainerConfig): CreateTurnstileChallengeContainer =>
    (options) => {
        const rootContainer = document.createElement("div");
        const widgetContainer = document.createElement("div");
        const root = createRoot(rootContainer);
        let isRemoved = false;

        widgetContainer.style.width = "100%";
        widgetContainer.style.minHeight = "65px";
        document.body.appendChild(rootContainer);

        const render = (isOpen: boolean) => {
            if (isRemoved) {
                return;
            }

            flushSync(() => {
                root.render(<ChallengeView isOpen={isOpen} onDismiss={options?.onDismiss} />);
            });
        };

        render(false);

        rootContainer.querySelector(`[${TURNSTILE_WIDGET_HOST_ATTRIBUTE}]`)?.appendChild(widgetContainer);

        return {
            widgetContainer,
            widgetTheme,
            show: () => {
                render(true);
            },
            remove: () => {
                if (isRemoved) {
                    return;
                }

                isRemoved = true;

                // Defer teardown so dismissal triggered from the view's own click handler does not unmount the root mid-event
                queueMicrotask(() => {
                    root.unmount();
                    rootContainer.remove();
                });
            }
        };
    };
import {ComponentType} from "react";
import {flushSync} from "react-dom";
import {createRoot} from "react-dom/client";

import {CreateTurnstileChallengeContainer, TurnstileWidgetTheme} from "./turnstile_challenge_container";

const TURNSTILE_WIDGET_HOST_ATTRIBUTE = "data-turnstile-widget-host";

export interface ITurnstileChallengeViewProps {
    /*
    The view must stay mounted in both states and toggle its visibility with CSS only. Turnstile renders its iframe into the
    widget host before the view opens and reparenting a live iframe reloads it, which breaks the challenge.
    */
    isOpen: boolean;
    onDismiss?: () => void;
}

interface ITurnstileWidgetHostProps {
    className?: string;
}

// Marks the element the Turnstile widget is rendered into - the view must render it exactly once
export const TurnstileWidgetHost = ({className}: ITurnstileWidgetHostProps) => <div className={className} {...{[TURNSTILE_WIDGET_HOST_ATTRIBUTE]: "true"}} />;

interface ICreateReactTurnstileChallengeContainerConfig {
    ChallengeView: ComponentType<ITurnstileChallengeViewProps>;
    widgetTheme?: TurnstileWidgetTheme;
}

export const createReactTurnstileChallengeContainer =
    ({ChallengeView, widgetTheme}: ICreateReactTurnstileChallengeContainerConfig): CreateTurnstileChallengeContainer =>
    (options) => {
        const rootContainer = document.createElement("div");
        const widgetContainer = document.createElement("div");
        const root = createRoot(rootContainer);
        let isRemoved = false;

        widgetContainer.style.width = "100%";
        widgetContainer.style.minHeight = "65px";
        document.body.appendChild(rootContainer);

        const render = (isOpen: boolean) => {
            if (isRemoved) {
                return;
            }

            flushSync(() => {
                root.render(<ChallengeView isOpen={isOpen} onDismiss={options?.onDismiss} />);
            });
        };

        render(false);

        rootContainer.querySelector(`[${TURNSTILE_WIDGET_HOST_ATTRIBUTE}]`)?.appendChild(widgetContainer);

        return {
            widgetContainer,
            widgetTheme,
            show: () => {
                render(true);
            },
            remove: () => {
                if (isRemoved) {
                    return;
                }

                isRemoved = true;

                // Defer teardown so dismissal triggered from the view's own click handler does not unmount the root mid-event
                queueMicrotask(() => {
                    root.unmount();
                    rootContainer.remove();
                });
            }
        };
    };
